import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PageContent = lazy(() => import('./PageContent'));
const PartnersContentPage = lazy(() => import('./pages/PartnersContentPage'));
const TermsContentPage = lazy(() => import('./pages/TermsContentPage'));
const PrivacyContentPage = lazy(() => import('./pages/PrivacyContentPage'));
const RentalAgreementContentPage = lazy(() => import('./pages/RentalAgreementContentPage'));
const FAQContentPage = lazy(() => import('./pages/FAQContentPage'));

const pageContentRoute: FuseRouteItemType = {
	path: 'page-content',
	children: [
		{ path: 'home', element: <PageContent /> },
		{ path: 'terms', element: <TermsContentPage /> },
		{ path: 'privacy', element: <PrivacyContentPage /> },
		{ path: 'rental-agreement', element: <RentalAgreementContentPage /> },
		{ path: 'faq', element: <FAQContentPage /> },
		{ path: 'partners', element: <PartnersContentPage /> }
	]
};

export default pageContentRoute;
